"use client";

import { HStack } from '@chakra-ui/react';
import { STYLES } from '~/components/utility/utils';

export const SuggestionsButtonList = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <HStack
      spacing="2"
      py="4"
      overflowX="auto"
      overflowY="hidden"
      style={{ WebkitOverflowScrolling: 'touch' }}
      sx={{
        ...STYLES.hideScrollbar
      }}
    >
      {children}
    </HStack>
  );
};
